import { Helmet } from "react-helmet-async";

const SITE = "https://pflegeheim-kosten-fuer-angehoerige.de";
const DEFAULT_TITLE =
    "Pflegeheimkosten für Angehörige: kostenlose Ersteinschätzung | pflegeheim-kosten-fuer-angehoerige.de";
const DEFAULT_DESC =
    "Müssen Sie das Pflegeheim Ihrer Eltern zahlen? Prüfen Sie kostenlos und in wenigen Minuten, ob Pflegeheimkosten für Sie finanziell relevant sind. 100.000-€-Grenze, Elternunterhalt, Heimkosten – verständlich erklärt, diskret, DSGVO-konform.";

export default function Seo({
    title,
    description = DEFAULT_DESC,
    path = "/",
    noIndex = false,
    ogType = "website",
    jsonLd = null,
}) {
    const fullTitle = title ? `${title} | Pflegeheim-Kosten für Angehörige` : DEFAULT_TITLE;
    const url = `${SITE}${path}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            {noIndex ? (
                <meta name="robots" content="noindex, nofollow" />
            ) : (
                <meta
                    name="robots"
                    content="index, follow, max-snippet:-1, max-image-preview:large"
                />
            )}
            <meta property="og:type" content={ogType} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            {jsonLd && (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            )}
        </Helmet>
    );
}
